<i18n>
{
  "fr": {
    "coord-title": "Coordonnées",
    "projection-code": "Projection utilisée",
    "EPSG:32632": "SCR UTM Nord Zone 32",
    "coord-start-title": "Coordonnées de départ",
    "coord-end-title": "Coordonnées d'arrivée",
    "line-length-title": "Longueur"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="container tool" id="coordinate" v-if="show">
    <div v-if="geomType === 'Point'">
      <p><b>{{ $t('coord-title') }}:</b> {{ currentGeom.coordinates[0] | formatNumber }} / {{ currentGeom.coordinates[1] | formatNumber }}</p>
      <p><b>{{ $t('projection-code') }}</b>: <a :href="`https://epsg.io/${projectionCode.split(':')[1]}`" target="_blank">{{ $t(projectionCode) }}</a></p>
    </div>
    <div v-if="geomType === 'LineString'">
      <p><b>{{ $t('coord-start-title') }}:</b> {{ currentGeom.coordinates[0][0] | formatNumber }} / {{ currentGeom.coordinates[0][1] | formatNumber }}</p>
      <p><b>{{ $t('coord-end-title') }}:</b> {{ currentGeom.coordinates[1][0] | formatNumber }} / {{ currentGeom.coordinates[1][1] | formatNumber }}</p>
      <p><b>{{ $t('line-length-title') }}:</b> {{ lineLength | formatNumber }} m</p>
    </div>
  </div>
</template>

<script>

import MapStoreMixin from '@/mixins/store/map'
import GeomToolbox from '@/utils/geomToolbox'
import Config from '@/config'

export default {
  name: 'CurrentCoordinate',
  mixins: [
    MapStoreMixin
  ],
  filters: {
    formatNumber (value) {
      return new Intl.NumberFormat('fr-CH', {
        style: 'decimal'
      }).format(value.toFixed(0)).replaceAll(' ', '\'')
    }
  },
  computed: {
    show () {
      return this.currentGeom !== null
    },
    geomType () {
      return this.currentGeom.type
    },
    lineLength () {
      return GeomToolbox.getLength(this.currentGeom)
    },
    projectionCode () {
      return Config.mapConfiguration.projection
    }
  }
}

</script>

<style lang="scss" scoped>
  .wide #coordinate {
    width: calc(50% - 5px);
    margin-left: 5px;
  }
</style>
